export default __webpack_public_path__ + "static/media/012-carambola.20c62dc5.svg";